import { Injectable, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VideoPlayerService {
  openVideoPlayer = false;
  playerObservable = new BehaviorSubject([]);
  titleObservable = new BehaviorSubject([]);
  video = this.playerObservable.asObservable();
  title = this.titleObservable.asObservable();

  @Output()
  update: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  toggle() {
    this.openVideoPlayer = !this.openVideoPlayer;
    this.update.emit(this.openVideoPlayer);
  }

  setVideo(video) {
    this.playerObservable.next(video);
  }

  setTitle(title) {
    this.titleObservable.next(title);
  }
}
